import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ShopSettingsService } from '../../general/services/shop-settings.service';

@Injectable({
  providedIn: 'root'
})
export class AssetsService {

  constructor(
    private shopSettingsService: ShopSettingsService,
  ) {
  }

  private get vuBaseUrl(): string {
    return this.shopSettingsService.vuBaseUrl;
  }

  getBackgroundImagesPathUrl(): string {
    return `${this.vuBaseUrl}/static/images/info/`;
  }

  getImageUrlById(imageId: number): string {
    return this.getFullUrl(this.getBackgroundImageName(imageId));
  }

  getBackgroundImageName(imageId: number): string {
    if (imageId < 0) {
      return `image_demo${Math.abs(imageId)}.jpg`;
    }

    return `image_${imageId}.jpg`;
  }

  getCategoryImageUrl(categoryId: number): string {
    return this.getFullUrl(this.getBackgroundCategoryImageName(categoryId));
  }

  getBackgroundCategoryImageName(categoryId: number): string {
    return `category_${categoryId}.jpg`;
  }

  getFullUrl(fileName: string): string {
    return this.getBackgroundImagesPathUrl() + fileName;
  }
}
